import { NotFoundError } from '@cian/peperrors/shared';

import { type IApplicationContext } from '@/app/shared/types/ApplicationContext';

import { type CianAnalyticsPageViewObject } from '@/packages/utils/analytics/CianAnalyticsPageViewObject';

type Params = {
  domain: string;
  isPin: boolean;
  page: CianAnalyticsPageViewObject['page'] | undefined;
  products: CianAnalyticsPageViewObject['products'] | undefined;
  user: CianAnalyticsPageViewObject['user'] | undefined;
};

export function logAnalyticsFieldsDegradation(context: IApplicationContext, params: Params): boolean {
  const { logger } = context;

  const { page, products, user, domain, isPin } = params;

  if ([page, products, user].some(el => el === undefined)) {
    const notFoundError = new NotFoundError({
      details: {
        description: 'Если поле false, то оно не было отправлено',
        isPin,
        page: !!page,
        products: !!products,
        user: !!user,
      },
      domain,
      message:
        'В аналитику не уйдут поля, описанные в details. Это произойдёт из-за отсутствия данных по ним, скорее всего или запрос не был вызван или завершился с ошибкой',
    });

    logger.error(notFoundError);

    return true;
  }

  return false;
}
